import { t } from "components/CentralDataMangement/translation/Translation";
import type { VisitsDetails } from "../Annotations";
import TableTitle from "components/common/atoms/TableTitle";

interface VisitsTableProps {
    data?: VisitsDetails[];
    tableTitle?: string;
}
const VisitsTable: React.FC<VisitsTableProps> = ({ data, tableTitle }) => {
    return (
        <>
            {tableTitle &&
                <TableTitle title={tableTitle} />
            }
            <div className="starter-table-height marginBotttom1 scrollBarDesign">
                <table className="table table-hover table-bordered">
                    <thead>
                        <tr className="TableHeader">
                            <th style={{ width: "15%" }}>{t("Date")}</th>
                            <th style={{ width: "25%" }}>{t("Company")}</th>
                            <th style={{ width: "25%" }}>{t("Info")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.length && data?.length > 0 ? (
                            data?.map((visit: VisitsDetails, index) => (
                                <tr key={index}>
                                    <td className="align-middle text-break">
                                        {visit.is_workplace_visit && (<strong className="color-dark-pink">(BV) </strong>)}
                                        {visit.date}
                                    </td>
                                    <td className="align-middle text-break">{visit.company}</td>
                                    <td className="align-middle text-break">{visit.info}</td>
                                </tr>
                            ))) : (
                            <tr>
                                <td colSpan={3}>
                                    <div className="text-danger text-center">
                                        {t("No data found")}
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default VisitsTable;